import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { WtfAnimations } from '../../../../utils/others/core/animations';

@Component({
  selector: 'wtf-pagelayoutfull',
  templateUrl: './pagelayoutfull.component.html',
  styleUrls: ['./pagelayoutfull.component.scss'],
  animations: WtfAnimations,
  encapsulation: ViewEncapsulation.None,
})
export class PagelayoutFullComponent implements OnInit {

  @Input() title: string;



  constructor() { }


  ngOnInit() {
  }

}
